import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useObservableAndState } from '@provider-portal/common/hooks/useObservableAndState';
import { BrazeCustomEvent } from '@provider-portal/common/services/BrazeService';
import { useCommonAppServices } from '@provider-portal/common/services/ContextProviders';

const BRAZE_NAVIGATION_TRACKED_PATHS = new Set(['/dashboard/home', '/smart-promotions/promotions']);

export function PageChangeTracker() {
  const { trackingService, brazeService, accountService } = useCommonAppServices();
  const location = useLocation();
  const selectedProvider = useObservableAndState(accountService.getSelectedProviderData$());
  const providerId = selectedProvider?.providerId;

  useEffect(() => {
    trackingService.pushPageChangeEvent({ url: location.pathname });
  }, [trackingService, location.pathname]);

  useEffect(() => {
    if (!providerId || !BRAZE_NAVIGATION_TRACKED_PATHS.has(location.pathname)) {
      return;
    }

    brazeService.logCustomEvent(BrazeCustomEvent.MERCHANT_PORTAL_NAVIGATION, {
      href: location.pathname,
    });
  }, [providerId, brazeService, location.pathname]);

  return null;
}
